<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
	[tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg" [token]="token">

	<ng-container *ngIf="consulta">

		<ul class="card-list-striped">
			<li><span class="text-secondary">MARCA
				</span><span>{{consulta?.marca || "NÃO INFORMADO"}}</span></li>

			<li><span class="text-secondary">PLACA
				</span><span>{{consulta?.placa || "NÃO INFORMADO"}}</span></li>

            <li><span class="text-secondary">RENAVAM
				</span><span>{{consulta?.renavam || "NÃO INFORMADO"}}</span></li>

            <li><span class="text-secondary">DOCUMENTO
				</span><span>{{consulta?.documento || "NÃO INFORMADO"}}</span></li>

			<li><span class="text-secondary">UF
				</span><span>{{consulta?.uf || "NÃO INFORMADO"}}</span></li>

            <li><span class="text-secondary">MUNICÍPIO
                    </span><span>{{consulta?.municipio || "NÃO INFORMADO"}}</span></li>

			<li><span class="text-secondary">ANO FABRICAÇÃO
				</span><span>{{consulta?.anoFabricacao || "NÃO INFORMADO"}}</span></li>

			<li><span class="text-secondary">ANO MODELO
				</span><span>{{consulta?.anoModelo || "NÃO INFORMADO"}}</span></li>

			<li><span class="text-secondary">URL CRLV-E
				</span><span><a href="{{consulta?.urlFotoDocumento}}" target="_blank">{{consulta?.urlFotoDocumento}}</a></span></li>
		</ul>

	</ng-container>

</app-card-consulta>
